import React from 'react';

import type { Props as DefaultEventStatusProps } from '@swf/sports/components/EventStatus/components/DefaultEventStatus/DefaultEventStatus';
import type { EventTypeId } from '@swf/sports/types/eventType';

import styles from './EventStatus.scss';

interface MarketNameProps extends DefaultEventStatusProps {
  eventTypeId: EventTypeId;
  marketName: string;
  badge?: never;
}

interface BadgeProps extends DefaultEventStatusProps {
  eventTypeId?: never;
  marketName?: never;
  badge: React.ReactElement;
}

const EventStatus: React.FC<MarketNameProps | BadgeProps> = (props) => (
  <div className={styles.container}>
    {'badge' in props ? (
      props.badge
    ) : (
      <div className={styles.marketNameContainer}>
        <span>{props.marketName}</span>
      </div>
    )}
  </div>
);

export default EventStatus;
